import React, {useEffect, useMemo, useState} from "react";
import ModalSkeleton from "../../../Modals/ModalSkeleton";
import CustomButton from "../../../common/Button/CustomButton";
import {apiGetRequest, apiPostRequest} from "../../../../helpers/Requests";
import {toast} from "react-toastify";
import CircularLoader from "../../../common/CircularLoader/CircularLoader";
import { HiOutlineExclamationCircle } from 'react-icons/hi';
import { useParams } from "react-router-dom";
import {roleAccess} from "../../../../helpers/RolesPermission";
import {USER_ROLE} from "../../../../Constants/constant";
const ViewMedicationPlanModal = (props) => {
    const { open, handleClose, setOpen} = props;
    const { uuid } = useParams();

    const [fileUrl, setFileUrl] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);


    const fetchFile = async () => {
        setLoading(true);
        try{

            const isAdminOrManager = roleAccess([USER_ROLE.Sp_Admin,USER_ROLE.Sp_manager]);
            const endPoint = isAdminOrManager ? 'sp/viewMedicationPlanFile' : 'worker/viewMedicationPlanFile';
            const response = await apiPostRequest(endPoint, {uuid});
            const data = response?.data?.data;
            if (typeof  data === 'string') {
                setFileUrl(data);
            } else {
                data?.original?.error && setError(data.original.error);
                setFileUrl(null);
            }
        } catch (e) {
            toast.error(e?.message ?? 'Something went wrong while loading the medication plan.');
            setFileUrl(null);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (open) {
            fetchFile();
        }
    },[open]);

    const renderFileViewer = () => {
        if (!fileUrl) {
            return (
                <div className="flex items-center justify-center h-[300px] text-center font-bold text-red-600 text-xl">
                    <HiOutlineExclamationCircle className="mr-2 text-3xl" />
                    {error || 'Medication plan has not been uploaded.'}
                </div>
            );
        }
        const lowerUrl = fileUrl.toLowerCase();

        const officeExtensions = ['.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx'];
        const isOfficeFile = officeExtensions.some(ext => lowerUrl.endsWith(ext));
        const isPdf = lowerUrl.endsWith('.pdf');
        const isImage = ['.jpeg', '.jpg', '.png', '.gif'].some(ext => lowerUrl.endsWith(ext));

        let viewerUrl = fileUrl;
        if (isOfficeFile) {
            viewerUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(fileUrl)}`;
        } else if (isPdf) {
            viewerUrl = `${fileUrl}#toolbar=0&navpanes=0&zoom=170`;
        }
        return (
            <div
                className="flex justify-center items-center p-4"
                style={{
                    height: isImage ? 'auto' : '75vh',
                    minHeight: isImage ? undefined : '500px',
                }}
            >
                {isImage ? (
                    <img
                        src={viewerUrl}
                        alt="File Preview"
                        style={{
                            maxWidth: '100%',
                            maxHeight: '60vh',
                            objectFit: 'contain',
                            borderRadius: '8px',
                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                        }}
                    />
                ) : (
                    <iframe
                        src={viewerUrl}
                        width="100%"
                        height="100%"
                        title="File Preview"
                        style={{
                            border: 'none',
                            borderRadius: '8px',
                            backgroundColor: '#fafafa',
                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                        }}
                    />
                )}
            </div>
        );
    };

    const modalFooter = () => {
        return (
            <CustomButton label='Close' onClick={handleClose} variant='danger' />
        );
    };

    return (
        <ModalSkeleton
            modalFooter={modalFooter()}
            isOpen={open}
            closeModal={() => setOpen(false)}
            title="View Medication Plan"
            cssClass="w-[85%] h-[90%]"
        >
            <div className="flex flex-col gap-2">
                {
                    loading ? (
                        <div className="flex justify-center items-center w-full bg-gray-50 lg:col-span-12 xl:col-span-12">
                            <CircularLoader
                                classes="flex justify-center items-center"
                                classloader="loader-l"
                            />
                        </div>
                    ) : (
                        renderFileViewer()
                    )
                }
            </div>
        </ModalSkeleton>
    );
}

export default ViewMedicationPlanModal;
